import styled from "styled-components";

export const Container = styled.div`
  /* background-color: ${({ theme }) =>
    theme.insuranceDetailsCard.backgroundColor ?? "#f5f9f0"}; */
  background-color: var(--p-color-surface-1);
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  padding: ${({ theme: { spacing } }) =>
    `${spacing.sm} ${spacing.lg} ${spacing.sm} ${spacing.xl}`};
  position: relative;

  /* & * {
    background-color: ${({ theme }) =>
    theme.insuranceDetailsCard.backgroundColor ?? "#f5f9f0"};
  } */
`;

export const InsuranceInformation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > * {
    display: flex;
    flex-direction: column;
  }
`;

export const MarginBottomContainer = styled.span`
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;
